module.exports = __webpack_public_path__ + "static/Agile-66f5ab4d6e08f7d21549bba4c832de8b.png";